@if (visible) {
  <div class="spinner" [class.dark-mode]="darkMode">
    &nbsp;
    <div class="cssload-loader">
      <div></div>
      <div></div>
    </div>
    &nbsp;
  </div>
}
